import React from 'react';
import JsonLD from '@components/JsonLD/JsonLD';

// Extract the JSON from the Prismic fields and pass it to JsonLD which will render the json within <script application/ld+json/> tags
export function StructruedData({ schemaJson }) {
  return (
    <>
      {schemaJson
        ? schemaJson
            .filter(item => item.structured_data.text)
            .map((item, i) => {
              // If included, remove script tags wrappers in order to parse the JSON successfully to the JsonLD component
              const jsonStr = item.structured_data.text
                .replace(`<script type="application/ld+json">`, '')
                .replace(`</script>`, '');
              return <JsonLD key={`${jsonStr}-${i}`}>{JSON.parse(jsonStr)}</JsonLD>;
            })
        : null}
    </>
  );
}

export default StructruedData;
